var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var TextoAvisoFilter = /** @class */ (function (_super) {
    __extends(TextoAvisoFilter, _super);
    function TextoAvisoFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.titulo = '';
        _this.fechaInicio = null;
        _this.fechaFin = null;
        _this.idioma = '';
        _this.permiteLogIn = null;
        _this.labels['titulo'] = _this.i18n('Títol');
        _this.labels['fechaInicio'] = _this.i18n('Data Inici');
        _this.labels['fechaFin'] = _this.i18n('Data Fi');
        _this.labels['idioma'] = _this.i18n('Idioma');
        _this.labels['permiteLogIn'] = _this.i18n('Permet Log In');
        return _this;
    }
    return TextoAvisoFilter;
}(FilterData));
export { TextoAvisoFilter };
